import React from 'react';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import { BiSearch } from 'react-icons/bi';
import { BsList, BsGridFill, BsHeart, BsHeartFill } from 'react-icons/bs';
import Button from 'modules/common/Button';

function Filter({ onSubmit, value }) {
  const [form, setForm] = React.useState(value);
  // eslint-disable-next-line
  const debounceSubmit = React.useCallback(
    debounce((newState) => {
      onSubmit(newState);
    }, 500),
    [onSubmit]
  );
  const handleChange = ({ target }) => {
    setForm((state) => {
      const newState = { ...state, [target.name]: target.value };
      debounceSubmit(newState);
      return newState;
    });
  };
  const handleToggleView = (view) => () => {
    onSubmit((state) => ({ ...state, view }));
  };
  const handleToggleFav = () => {
    onSubmit((state) => ({ ...state, favorite: state.favorite ? 0 : 1 }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };
  return (
    <form onSubmit={handleSubmit}>
      <div className="flex items-center relative">
        <div className="absolute left-0 mx-1">
          <BiSearch className="h-6 w-6" />
        </div>
        <input
          className="flex-grow bg-transparent border-b-2 focus:border-primary-500 focus:outline-none pl-8 py-1"
          name="keyword"
          onChange={handleChange}
          value={form.keyword}
        />
        <div className="flex">
          <Button
            className={value?.view === 'list' ? 'text-primary-500' : ''}
            size="xs"
            transparent
            icon={BsList}
            onClick={handleToggleView('list')}
          />
          <Button
            className={value?.view === 'grid' ? 'text-primary-500' : ''}
            size="xs"
            transparent
            icon={BsGridFill}
            onClick={handleToggleView('grid')}
          />
          <Button
            className={value?.favorite ? 'text-primary-500' : ''}
            size="xs"
            transparent
            icon={value?.favorite ? BsHeartFill : BsHeart}
            onClick={handleToggleFav}
          />
        </div>
      </div>
    </form>
  );
}

Filter.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.instanceOf(Object).isRequired,
};

export default Filter;
